import type { AxiosRequestConfig } from "axios";
import { Header } from "@/core/types/header.type";
import api, { CanceledError } from "@/core/utils/axios-instance";

class ApiService {
	constructor() {
		// Set the base URL for all requests
		api.defaults.headers.common.Accept = Header.APPLICATION_JSON;
		api.defaults.headers.common["Content-Type"] = Header.APPLICATION_JSON;
		// axios.defaults.withCredentials = true;
	}

	async get<T, Q = unknown>(
		url: string,
		params?: Q,
		signal?: AbortSignal,
	): Promise<T> {
		const response = await api({
			method: "get",
			url: url,
			params: params,
			signal: signal,
		});
		return response.data as T;
	}

	async post<T, B = unknown>(
		url: string,
		body: B,
		options?: { skipAuth?: boolean },
	): Promise<T> {
		const config: AxiosRequestConfig & { skipAuth?: boolean } = {
			method: "post",
			url: url,
			data: body,
		};
		if (options?.skipAuth) {
			config.skipAuth = true;
		}
		const response = await api(config);
		return response.data as T;
	}

	async put<T, B = unknown>(url: string, body?: B): Promise<T> {
		const response = await api({
			method: "put",
			url: url,
			data: body,
		});
		return response.data as T;
	}

	async patch<B = unknown>(url: string, body: B): Promise<void> {
		await api({
			method: "patch",
			url: url,
			data: body,
		});
	}

	async delete<B = unknown>(url: string, body?: B): Promise<void> {
		await api({
			method: "delete",
			url: url,
			data: body,
		});
	}

	async head<B = unknown>(url: string, body?: B): Promise<void> {
		await api({
			method: "head",
			url: url,
			data: body,
		});
	}
}

export default ApiService;

export { CanceledError };
